import React from "react";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const StyledToolbarContainer = styled(GridToolbarContainer)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
}));

export default function AllocationProfilesToolbar({
  onAddNewRecord,
  showInactive,
  onShowInactiveChange,
}) {
  return (
    <StyledToolbarContainer>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <FormControlLabel
          control={
            <Switch
              checked={showInactive}
              onChange={(e) => onShowInactiveChange(e.target.checked)}
              sx={{ ml: 2 }}
            />
          }
          label="Show Inactive Profiles"
        />
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button variant="contained" onClick={onAddNewRecord} color="secondary">
          Create Allocation Profile
        </Button>
      </Box>
    </StyledToolbarContainer>
  );
}
